var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "SwiperIframe" }, [
    _c("div", { staticClass: "swiper" }, [
      _c(
        "div",
        { staticClass: "swiper-wrapper" },
        _vm._l(_vm.urlList, function(item, index) {
          return _c("div", { key: index, staticClass: "swiper-slide" }, [
            _c("iframe", { attrs: { src: item.url, frameborder: "0" } })
          ])
        }),
        0
      ),
      _c("div", { staticClass: "swiper-button-prev" }),
      _c("div", { staticClass: "swiper-button-next" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }